import React, { useEffect, useState } from "react";
import CreatePublishHomework from "../create_published/CreatePublishHomework";
import PreAttach from "./pre_question_type/PreAttach";
import PreMcq from "./pre_question_type/PreMcq";
import "./QuestionListHomework.css";
import DraftPublishHW from "../../On_going/Draft/Draft_Assess_Box/Draft_Q_list/DraftPublishHW";
const QuestionList = ({
  change,
  questions,
  setQuestions,
  assessmentDetails,
  setAssessmentDetails,
  isForEditing,
  isScheduledEditing,
  total_marks,
  name,
}) => {
  const [click, setClick] = useState(false);

  return (
    <>
      {!click && (
        <div className="preview_transprant_body">
          <div className=" p-2 preview_container shadow">
            <img
              src="/images/cross-circle3.svg"
              className="preview_Q_close_btn"
              alt=""
              onClick={(e) => change(false)}
            />
            <div className=" col-12 mt-3 d-flex align-items-center justify-content-between">
              <span className="preview_container_header">
                {/* Preview Homework */}
                {name}
              </span>
              <button className="Edit_Btn" onClick={(e) => setClick(true)}>
                Publish
              </button>
            </div>
            <div className="m-3 preview_marks_time_container">
              <div className="List_Width p-1 preview_marks_time_management">
                <div className=" col-4 qno_manage">
                  <span className="">Total Questions :</span>
                  <span> {questions?.length}</span>
                </div>
                <div className=" col-4 qno_manage">
                  <span className="">Total Marks :</span>
                  <span> {total_marks}</span>
                </div>

                <div className=" col-4 qno_manage">
                  <span className="">Total Duration :</span>
                  <span>
                    {" "}
                    {assessmentDetails?.total_duration
                      ? assessmentDetails?.total_duration + "min"
                      : "-"}{" "}
                    {" "}
                  </span>
                </div>
              </div>
            </div>
            <div className="preview_question_lists">
              {questions.length > 0 &&
                questions.map((question, index) =>
                  question.question_type === "false" ? (
                    <PreMcq
                      key={index}
                      nextQuestion={index}
                      question={question}
                    />
                  ) : (
                    <PreAttach
                      key={index}
                      nextQuestion={index}
                      question={question}
                    />
                  )
                )}
            </div>
          </div>
        </div>
      )}
      {click && (
        <CreatePublishHomework
          setClick={setClick}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          questions={questions}
        />
      )}
      {click && (isForEditing || isScheduledEditing) && (
        <DraftPublishHW
          setClick={setClick}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          questions={questions}
          isScheduledEditing={isScheduledEditing}
        />
      )}
    </>
  );
};
export default QuestionList;
